import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`

  .intent-danger {
    color: ${(props) => props.theme.colors.deepRose};
  }

  a,
  abbr,
  acronym,
  address,
  applet,
  article,
  aside,
  audio,
  b,
  big,
  blockquote,
  body,
  canvas,
  caption,
  center,
  cite,
  code,
  dd,
  del,
  details,
  dfn,
  div,
  dl,
  dt,
  em,
  embed,
  fieldset,
  figcaption,
  figure,
  footer,
  form,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  header,
  hgroup,
  html,
  i,
  iframe,
  img,
  ins,
  kbd,
  label,
  legend,
  li,
  mark,
  menu,
  nav,
  object,
  ol,
  output,
  p,
  pre,
  q,
  ruby,
  s,
  samp,
  section,
  small,
  span,
  strike,
  strong,
  sub,
  summary,
  sup,
  table,
  tbody,
  td,
  tfoot,
  th,
  thead,
  time,
  tr,
  tt,
  u,
  ul,
  var,
  video {
    margin: 0;
    padding: 0;
    border: 0;
    font: inherit;
    vertical-align: baseline;
  }

  article,
  aside,
  canvas,
  figcaption,
  figure,
  footer,
  header,
  hgroup,
  main,
  output,
  section {
    display: block;
  }

  body {
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  body.modal-open {
    overflow: hidden;
  }

  ol, ul {
    list-style: none;
    line-height: 1.6
  }

  blockquote, q {
    quotes: none;
    &::before, &::after {
      content: "";
      display: none;
    }
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  input, textarea, button, select {
    appearance: none;
    background: none;
    border-color: currentColor;
    border-style: none;
    border-width: medium;
    border-radius: 0;
    margin: 0;
    padding: 0;
    color: inherit;
    font-style: inherit;
    font-variant: inherit;
    font-weight: inherit;
    font-stretch: inherit;
    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
    vertical-align: baseline;
  }

  input:read-only {
    color: ${(props) => props.theme.colors.steel};
  }

  input::placeholder {
    opacity: 1;
    color: inherit;
    font-style: inherit;
    font-variant: inherit;
    font-weight: inherit;
    font-stretch: inherit;
    font-size: inherit;
    font-family: inherit;
  }

  a:link {
    text-decoration: none;
  }

  a:link, a:visited, a:hover, a:active {
    color: inherit;
  }

  b {
    font-weight: 600;
  }

  ::-webkit-inner-spin-button {
    appearance: none;
  }
  ::-webkit-outer-spin-button {
    appearance: none;
  }
  ::-webkit-search-cancel-button {
    appearance: none;
  }
  ::-webkit-search-results-button {
    appearance: none;
  }
  ::-ms-clear, ::-ms-reveal {
    display: none;
  }
  ::-webkit-contacts-auto-fill-button {
    display: none !important;
  }

  input {
    -moz-appearance: textfield;
    border-radius: ${(props) => props.theme.styles.borderRadius};
    background-color: ${(props) => props.theme.colors.white};

    ::placeholder {
      font-weight: 500;
      color: ${(props) => props.theme.colors.steel}80;
    }
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  html {
    box-sizing: border-box;
  }

  html {
    height: 100%;
  }

  body {
    min-height: 100%;
    ${(props) => props.theme.text.body};
  }

  body > div.root {
    min-height: 100%;
  }

  #app {
    overflow: hidden;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
  }

  img {
    max-width: 100%;
  }

  h1 {
    font-family: Inter;
    font-size: 24px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    color: ${(props) => props.theme.colors.darkBlue};
    margin-bottom: 20px;
  }

  h4 {
    font-size: 15px;
    font-weight: 600;
    line-height: 20px;
    color: ${(props) => props.theme.colors.darkBlue};
    margin-bottom: 4px;
  }

  // Override the default Ant Tooltip designs
  .ant-tooltip-inner {
    color: ${(props) => props.theme.colors.darkBlue} !important;
    background-color: ${(props) => props.theme.colors.white} !important;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05) !important;
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    font-stretch: normal;
  }

  .ant-tooltip-placement-bottom .ant-tooltip-arrow, 
  .ant-tooltip-placement-bottomLeft .ant-tooltip-arrow,
  .ant-tooltip-placement-bottomRight .ant-tooltip-arrow {
      border-bottom-color: ${(props) => props.theme.colors.white} !important;
  }

  .ant-tooltip-arrow::before {
    background-color: ${(props) => props.theme.colors.white} !important;
  }

  // Override default react-tooltip styles
  .__react_component_tooltip {
    border-radius: 4px;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 0, 0, 0.05) !important;
  }

  // Bootstrap overrides
  .container-fluid, .container-sm, .container-md, .container-lg, .container-xl {
    padding-left: 0;
    padding-right: 0;
  }

  .customScrollbars::-webkit-scrollbar {
    width: 17px;
  }

  .customScrollbars::-webkit-scrollbar-track {
      background: ${(props) => props.theme.colors.offWhite};
  }

  .customScrollbars::-webkit-scrollbar-thumb {
    background-color: #aeaeae;    /* color of the scroll thumb */
    border-radius: 20px;       /* roundness of the scroll thumb */
    border: 5px solid ${(props) => props.theme.colors.offWhite};
  }


`;
